import { useQuery } from 'react-query';

import type { FormalDegreeKey } from '~/features/checkout/constants';
import { getCouponCodeFromCookie } from '~/features/discount/utils/get-coupon-code-from-cookie';
import { useCurrency } from '~/features/internationalization/hooks/use-currency';
import { useClientRender } from '~/hooks/use-client-render';

import { getDynamicPrice } from '../controllers/get-dynamic-price';
import { computeDynamicPriceResult } from '../utils/compute-dynamic-price';

export function useDynamicPrice(formalDegreeKey: FormalDegreeKey, { enabled = true }: { enabled?: boolean } = {}) {
  const isClientReady = useClientRender();
  const { currency, resolved: currencyResolved } = useCurrency();
  const coupon = isClientReady ? getCouponCodeFromCookie() : undefined;

  const { data, isLoading, isError } = useQuery(
    ['dynamicPrice', formalDegreeKey, currency, coupon],
    () => getDynamicPrice({ currency, formalDegreeKey, coupon }),
    { enabled: enabled && currencyResolved && Boolean(currency) }
  );

  if (!data) {
    return {
      isLoading: !isError,
      isError,
      total: null,
      maxTotal: null,
      formattedTotal: null,
      formattedEnrollmentFee: null,
      isDiscounted: false,
      currency: null,
      percentOff: null,
    };
  }

  return {
    isLoading,
    isError: false,
    ...computeDynamicPriceResult(data),
  };
}
